import React , { useState , useEffect } from 'react';
import { SoundOutlined , PauseCircleOutlined } from '@ant-design/icons';
import { debounce } from "lodash"
import { IconButton } from '@mui/material';
import { useAudio } from 'utils/context/AudioProvider';
import { handleTextToSpeech } from 'store/vocabulary/thunks';
import Loading from './Loading';
import { useDispatch } from 'react-redux';
import { setAudioChecker } from 'store/audio/actions';
import * as Sentry from '@sentry/react';
import { useAlert } from './UI/alertSakeBar/alertProvider';

const TextReader = ({ text, language = "en-US", style = {},
   stopAudio
  }) => {
  const showAlert = useAlert();
  const dispatch = useDispatch()
  const voice_text = Array.isArray(text) ? text.join(" ") : text
  const [isPlaying , setIsPlaying ] = useState(false);
  const [voices, setVoices] = useState([]);
  const { playAudio, audioRef, currentAudio } = useAudio();
  const [audio, setAudio] = useState(null);
  const [audioVersion, setAudioVersion] = useState('female');
  const [loader,setLoading] = useState(false);
  const [voiceSetting, setVoiceSetting] = useState({
    voice_languageCode: language === 'en-US' ? 'en-US' : 'es-ES',
    voice_name: language === 'en-US' ? 'en-US-Wavenet-F' : 'es-ES-Standard-A'
  });

  useEffect(() => {
    setVoiceSetting({
      voice_languageCode: language === 'en-US' ? 'en-US' : 'es-ES',
      voice_name: language === 'en-US' ? 'en-US-Wavenet-F' : 'es-ES-Standard-A',
    });
  }, [language]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
    dispatch(setAudioChecker({ isPlaying: false }));
    stopAudio();
    setAudio(null);
  }, [voice_text, language]);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying (false);
      dispatch(setAudioChecker({isPlaying: false}))
      stopAudio();
      setAudio(null);
    }
  }, [voiceSetting]);

  useEffect(() => {
    const audioEl = audioRef.current;
    if (audioEl) {
      const handleAudioEnd = async () => {
        audioEl.pause();
        audioEl.currentTime = 0;
        setIsPlaying (false);
        await dispatch(setAudioChecker({isPlaying: false}))
        setAudio(null);
        stopAudio();
      };

      audioEl.addEventListener('ended', handleAudioEnd);

      return () => {
        audioEl.removeEventListener('ended', handleAudioEnd);
      };
    }
  }, [audio]);

  const speakText = debounce(async () => {
    if (!voice_text) return; 
    if (audioRef.current && !audioRef.current.paused || isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setAudio(null);
      stopAudio();
      setIsPlaying(false);
      await dispatch(setAudioChecker({isPlaying: false}))
    } 

    try {
      setLoading(true)
      if (!audio) {
        const newIdea = {
          text: voice_text,
          pitch: '',
          volume: '',
          speed: audioVersion === 'male' ? 0.9 : '',
          voice_name: voiceSetting.voice_name,
          voice_languageCodes: voiceSetting.voice_languageCode
        };
        const data = await handleTextToSpeech(newIdea);
        const bytes = data?.body?.data;
        if (!Array.isArray(bytes)) {
          throw new Error('No audio data returned');
        }
        const audioBlob = new Blob([Uint8Array.from(bytes)], { type: 'audio/mp3' });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudio(audioUrl);
        playAudio(audioUrl);
        setIsPlaying (true);
        await dispatch(setAudioChecker({isPlaying: true}))
      } else {
        if (isPlaying) {
          audioRef.current.pause();
          setIsPlaying(false);
          await dispatch(setAudioChecker({isPlaying: false}))
          stopAudio()
        } else {
          audioRef.current.play();
          setIsPlaying(true);
          await dispatch(setAudioChecker({isPlaying: true}))
        }
      }
      setLoading(false)
    } catch (error) {
      Sentry.captureException(`250 Error in TextReader: ${error}`);
      setLoading(false)
      showAlert("Something went wrong", 'error')
    } 
  }, 1000);

  if (!voice_text) {
    return null; 
  }
  const icon = isPlaying  ? <PauseCircleOutlined /> : <SoundOutlined />;
  const iconStyle = { position: 'absolute', top: 5, right: 2, padding: 0, ...style };

  return (
    <IconButton onClick={speakText} style={iconStyle}>
      {loader?<Loading size={14} />: icon}
    </IconButton>
  );
};

export default TextReader;
